import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { LocationsDTO } from 'models'
import { FormDebtorKeys } from './types'

interface Schema {
    id: FormDebtorKeys
}

export const FormDebtorValue = (
    location: LocationsDTO[]
): {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] => [
    {
        input: {
            id: 'nome',
            label: 'Nome do devedor',
            maxLength: 128
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'Email'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        select: {
            id: 'tipoDocumento',
            label: 'Doc. devedor',
            optionsType: 'doc'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'documento',
            label: 'Nº do documento',
            inputMode: 'numeric',
            maskReplace: 'registro'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.municipio',
            label: 'Município'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        select: {
            id: 'endereco.uf',
            label: 'UF',
            optionsType: 'uf'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
        }
    },
    {
        input: {
            id: 'endereco.bairro',
            label: 'Bairro'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.logradouro',
            label: 'Logradouro'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 7 }
        }
    },
    {
        input: {
            id: 'endereco.numero',
            label: 'Número'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
        }
    },
    {
        input: {
            id: 'telefone',
            label: 'Telefone',
            maskReplace: 'contato',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.complemento',
            label: 'Complemento ou referência',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    }
]
